import {
  buildChallengeDeeplink,
  buildCollectionDeeplink,
  buildLeaderboardDeeplink,
  buildShareDeeplink,
  DEEPLINK_SCHEME,
} from '@repo/config';
import { stripLocalePrefix } from '@repo/web-chrome/lib/path';

function safeDecode(value: string): string {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
}

export function deeplinkFromPathname(pathname: string): string | null {
  const path = stripLocalePrefix(pathname);
  if (path === '/english-iq' || path.startsWith('/english-iq/')) {
    return null;
  }
  const challengeMatch = path.match(/^\/challenge\/([^/]+)/);
  if (challengeMatch?.[1]) {
    return buildChallengeDeeplink(safeDecode(challengeMatch[1]));
  }
  const collectionMatch = path.match(/^\/collection\/([^/]+)/);
  if (collectionMatch?.[1]) {
    return buildCollectionDeeplink(safeDecode(collectionMatch[1]));
  }
  if (path === '/leaderboard') {
    return buildLeaderboardDeeplink();
  }
  if (path === '/share') {
    return buildShareDeeplink();
  }
  return DEEPLINK_SCHEME;
}
